module.exports = __webpack_public_path__ + "media/images/fleche gauche-512423bf433a6eef9afec2838e160d6d.svg";